import styled from 'styled-components';
import { FLUENT_UI_EMOJIS } from '../../../../../../../../assets';
import { CaptionFont, Subtitle2Font } from '../../../../../../../../themes/fonts';
import { THEME } from '../../../../../../../../themes';

export const Icon = styled(FLUENT_UI_EMOJIS.CASTLE)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.TINY};
`;

export const Title = styled.span`
  ${Subtitle2Font};
  font-weight: bold;
  line-height: 1.14;
  letter-spacing: 0.46px;
`;

export const Description = styled.span`
  ${CaptionFont};
  letter-spacing: 0.4px;
`;
